import { createSlice } from '@reduxjs/toolkit';
export const initialRefDataState = [];
export const accountReferenceDataSlice = createSlice({
  name: 'accountReferenceData',
  initialState: initialRefDataState,
  reducers: {
    addRefData(state, action) {
      return [...state, action.payload];
    },
    addMultipleRefData(state, action) {
      const {
        referenceData = []
      } = action.payload;
      return [...state, ...referenceData];
    },
    addReferenceDataOptions(state, action) {
      const {
        reference_data_id,
        reference_data_column,
        referenceDataOptions
      } = action.payload;
      return state.map(refData => {
        if (refData.id !== reference_data_id) return refData;
        const existingColumns = refData.columns || {};
        const columnUpdate = {
          [reference_data_column]: referenceDataOptions
        };
        return {
          ...refData,
          columns: {
            ...existingColumns,
            ...columnUpdate
          }
        };
      });
    }
  }
});
export const {
  actions,
  reducer
} = accountReferenceDataSlice;
export default reducer;